import { render, staticRenderFns } from "./i18n.en.new.vue?vue&type=template&id=a49e30da&"
import script from "./i18n.en.new.vue?vue&type=script&lang=js&"
export * from "./i18n.en.new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports